import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export const SEMANTIC_SEARCH_DISCLAIMER_TEXT = "Wersja Beta. AI może się mylić. Zawsze potwierdzaj szczegóły oferty u dewelopera.";

export function SemanticSearchDisclaimer() {
    return (
        <Text variant="info_txt_2" as="p" align="center" className={disclaimer}>
            {SEMANTIC_SEARCH_DISCLAIMER_TEXT}
        </Text>
    );
}

const disclaimer = css({
    m: 0,
    pt: 2,
    px: 1.5,
    color: "var(--colors-gray-700)",

    "@container aiAdvisor (max-height: 720px)": {
        pt: 1
    },

    "@container aiAdvisor (max-height: 560px)": {
        pt: 0.5
    },

    "@container aiAdvisor (max-height: 420px)": {
        pt: 0
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export const SEMANTIC_SEARCH_DISCLAIMER_TEXT = "Wersja Beta. AI może się mylić. Zawsze potwierdzaj szczegóły oferty u dewelopera.";

export function SemanticSearchDisclaimer() {
    return (
        <Text variant="info_txt_2" as="p" align="center" className={disclaimer}>
            {SEMANTIC_SEARCH_DISCLAIMER_TEXT}
        </Text>
    );
}

const disclaimer = css({
    m: 0,
    pt: 2,
    px: 1.5,
    color: "var(--colors-gray-700)",

    "@container aiAdvisor (max-height: 720px)": {
        pt: 1
    },

    "@container aiAdvisor (max-height: 560px)": {
        pt: 0.5
    },

    "@container aiAdvisor (max-height: 420px)": {
        pt: 0
    }
});
